import { render, staticRenderFns } from "./TelCode.vue?vue&type=template&id=0d79bba6&scoped=true"
import script from "./TelCode.vue?vue&type=script&lang=js"
export * from "./TelCode.vue?vue&type=script&lang=js"
import style0 from "./TelCode.vue?vue&type=style&index=0&id=0d79bba6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d79bba6",
  null
  
)

export default component.exports